import React from 'react'
import {
  Alert as ModernAlert,
  Button as ModernButton,
  Card,
  Accordion,
  Modal as ModernModal,
  DropdownButton as ModernDropdownButton,
  Dropdown,
  ButtonGroup,
  Popover as ModernPopover,
  OverlayTrigger as ModernOverlayTrigger
} from 'react-bootstrap'
console.log('Loaded react-bootstrap-compat shim')
// 1. Panel -> Card
export const Panel = Card
export const PanelGroup = Accordion

// 2. Alert Shim (onDismiss -> onClose, bsStyle -> variant)
export const Alert = ({ bsStyle, onDismiss, ...props }: any) => (
  <ModernAlert variant={bsStyle || 'primary'} onClose={onDismiss} dismissible={!!onDismiss} {...props} />
)

// 3. Button Shim (bsStyle -> variant, bsSize mapping)
export const Button = ({ bsStyle, bsSize, ...props }: any) => {
  const sizeMap: any = { large: 'lg', small: 'sm', xsmall: 'sm' }
  return <ModernButton variant={bsStyle || 'primary'} size={sizeMap[bsSize]} {...props} />
}

// 4. DropdownButton Shim (bsStyle -> variant)
export const DropdownButton = ({ bsStyle, ...props }: any) => <ModernDropdownButton variant={bsStyle} {...props} />

// 4.5. SplitButton Shim (bsStyle -> variant, title -> children)
// Bootstrap 3 compatible split button - custom implementation
export const SplitButton = ({ bsStyle, title, onClick, children, id, disabled, className, ...props }: any) => {
  const [show, setShow] = React.useState(false)
  const dropdownRef = React.useRef<HTMLDivElement>(null)
  const variant = bsStyle || 'primary'

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShow(false)
      }
    }

    if (show) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [show])

  return (
    <div
      ref={dropdownRef}
      className={`btn-group ${className || ''}`}
      style={{ position: 'relative', display: 'inline-block' }}
      {...props}
    >
      <ModernButton variant={variant} onClick={onClick} disabled={disabled} className={`btn btn-${variant}`}>
        {title}
      </ModernButton>
      <ModernButton
        variant={variant}
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation()
          setShow(!show)
        }}
        className={`btn btn-${variant} dropdown-toggle`}
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded={show}
        style={{ paddingLeft: '8px', paddingRight: '8px' }}
      >
        <span className="sr-only">Toggle Dropdown</span>
      </ModernButton>
      <ul
        className={`dropdown-menu ${show ? 'show' : ''}`}
        style={{
          display: show ? 'block' : 'none',
          position: 'absolute',
          right: 0,
          top: '100%',
          zIndex: 1000
        }}
      >
        {React.Children.map(children, (child) =>
          React.cloneElement(child, {
            onClick: (e: any) => {
              child.props.onClick?.(e)
              setShow(false)
            }
          })
        )}
      </ul>
    </div>
  )
}

// 5. Modal Shim (Sub-component mapping)
export const Modal: any = (props: any) => <ModernModal {...props} />
const ModalHeader = ({ closeButton, ...props }: any) => <ModernModal.Header closeButton={closeButton} {...props} />
ModalHeader.displayName = 'Modal.Header'
Modal.Header = ModalHeader
Modal.Title = ModernModal.Title
Modal.Body = ModernModal.Body
Modal.Footer = ModernModal.Footer

// 6. Popover Shim (title prop -> Popover.Header component)
// v0.32.4 API: <Popover title="...">content</Popover>
// v2.x API: <Popover><Popover.Header>...</Popover.Header><Popover.Body>content</Popover.Body></Popover>
export const Popover = ({ title, children, ...props }: any) => {
  if (title) {
    // Legacy API with title prop - wrap children in Popover.Body
    return (
      <ModernPopover {...props}>
        <ModernPopover.Header>{title}</ModernPopover.Header>
        <ModernPopover.Body>{children}</ModernPopover.Body>
      </ModernPopover>
    )
  }
  // Modern API - pass through as is
  return <ModernPopover {...props}>{children}</ModernPopover>
}

// 7. OverlayTrigger - pass through (no API changes)
export const OverlayTrigger = ModernOverlayTrigger
